/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStorefrontScripts200ResponseInnerScripts } from './GetStorefrontScripts200ResponseInnerScripts';
import {
    GetStorefrontScripts200ResponseInnerScriptsFromJSON,
    GetStorefrontScripts200ResponseInnerScriptsFromJSONTyped,
    GetStorefrontScripts200ResponseInnerScriptsToJSON,
    GetStorefrontScripts200ResponseInnerScriptsToJSONTyped,
} from './GetStorefrontScripts200ResponseInnerScripts';

/**
 * 
 * @export
 * @interface GetStorefrontScripts200ResponseInner
 */
export interface GetStorefrontScripts200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {GetStorefrontScripts200ResponseInnerScripts}
     * @memberof GetStorefrontScripts200ResponseInner
     */
    scripts: GetStorefrontScripts200ResponseInnerScripts;
}

/**
 * Check if a given object implements the GetStorefrontScripts200ResponseInner interface.
 */
export function instanceOfGetStorefrontScripts200ResponseInner(value: object): value is GetStorefrontScripts200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scripts' in value) || value['scripts'] === undefined) return false;
    return true;
}

export function GetStorefrontScripts200ResponseInnerFromJSON(json: any): GetStorefrontScripts200ResponseInner {
    return GetStorefrontScripts200ResponseInnerFromJSONTyped(json, false);
}

export function GetStorefrontScripts200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontScripts200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'scripts': GetStorefrontScripts200ResponseInnerScriptsFromJSON(json['scripts']),
    };
}

export function GetStorefrontScripts200ResponseInnerToJSON(json: any): GetStorefrontScripts200ResponseInner {
    return GetStorefrontScripts200ResponseInnerToJSONTyped(json, false);
}

export function GetStorefrontScripts200ResponseInnerToJSONTyped(value?: GetStorefrontScripts200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'scripts': GetStorefrontScripts200ResponseInnerScriptsToJSON(value['scripts']),
    };
}

